module.exports = __webpack_public_path__ + "img/selfAdhesive3.a4ff1d7e.jpg";